import * as React from 'react';

export function SvgShare(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.987 3.15a1.631 1.631 0 011.853.343l5.658 5.705c.67.675.67 1.784 0 2.46L14.84 17.36a1.633 1.633 0 01-1.852.345 1.713 1.713 0 01-.997-1.576v-1.543c-3.415.376-5.919 2.787-7.22 5.742A.9.9 0 013 20.1v-.027a.9.9 0 01.009-.123c.242-3.288 1-6.407 2.526-8.851 1.438-2.302 3.547-3.984 6.456-4.628V4.724c0-.725.42-1.312.996-1.574zM5.424 16.072c1.821-1.963 4.34-3.326 7.463-3.338a.9.9 0 01.904.9v2.227l5.392-5.433-5.392-5.437v2.227a.9.9 0 01-.765.89c-2.743.418-4.657 1.851-5.964 3.944-.72 1.153-1.26 2.513-1.638 4.02zm8.138.02z"
        fill="currentColor"
      />
    </svg>
  );
}
